// extracted by mini-css-extract-plugin
module.exports = {"toutiao":"TouTiao_style_toutiao__38-K-","line":"TouTiao_style_line__2jYoQ","txt":"TouTiao_style_txt__3TRpA"};